import styled from 'styled-components';

import { devices } from '@/UI/Styles/Queries';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.brandTheme.brand100};
  color: ${({ theme }) => theme.tokens.color.text.default};

  @media ${devices['no-mobile']} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  @media ${devices.Large} {
    padding: 12px 16px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  align-items: flex-start;
  gap: 8px;
  min-width: 0;

  svg {
    flex-shrink: 0;
    margin-top: 3px;
    color: ${({ theme }) => theme.brandTheme.brand100};
  }
`;

export const Rows = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const Title = styled.span`
  color: ${({ theme }) => theme.brandTheme.brand100};
  font-size: 18px;
  font-weight: 500;
  line-height: 1.4;
`;

export const Row = styled.span`
  font-size: 14px;
  line-height: 1.4;

  strong {
    font-weight: 600;
  }
`;

export const DownloadLink = styled.a`
  width: 100%;
  flex-shrink: 0;
  padding: 8px 12px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.brandTheme.brand100};
  box-shadow: 0px 2px 2px 0px #39414914;
  color: #ffffff;
  font-size: 16px;
  text-align: center;
  text-decoration: none;

  &:hover {
    opacity: 0.9;
  }

  .short {
    display: inline;
  }

  .long {
    display: none;
  }

  @media ${devices['no-mobile']} {
    width: auto;
    padding: 4px 12px;

    .short {
      display: none;
    }

    .long {
      display: inline;
    }
  }
`;
